import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Loading, withAlertHandler } from 'entoro-shared';
import Dialog, {
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui/Dialog';
import Divider from 'material-ui/Divider';
import withLayout from '../withLayout';
import {
  offerPreviewQuery,
  wefunderRegistration,
  updateWefunderInvestorSuitabilityMutation,
} from '../../apollo';
import CompanySummary from '../OfferOverview/CompanySummary';
import OfferDetails from '../OfferOverview/OfferDetails';
import YoutubeBackground from 'react-youtube-background';
import AnonOfferListItems from '../OfferOverview/AnonOfferListItems';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import RegisterForm from './register/RegisterForm';
import WefunderSuitabilty from './register/WefunderSuitabilty';
import Slide from 'material-ui/transitions/Slide';
import Footer from '../../Layouts/Footer';
import { withStyles } from 'material-ui/styles';

const styles = {
  appBar: {
    position: 'relative',
    height: '20vh',
    minHeight: '0rem',
  },
  flex: {
    flex: 1,
  },
};

class WefunderOffer extends React.Component {
  state = {
    showPosition: false,
    showRegister: false,
    showsuitability: false,
    userId: null,
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    if (localStorage.authToken) {
      localStorage.removeItem('authToken');
    }
  }

  transition = (props) => {
    return <Slide direction='up' {...props} />;
  };

  handleSuitability = () => {
    this.setState({ showRegister: false });

    this.setState({ showsuitability: true });
  };
  handleRegistration = (e) => {
    this.setState({ showRegister: true });
  };

  submitSuitability = async (variables, redirect = true) => {
    const { client, handleSnackbarError, data } = this.props;

    const { offerPreview } = data;

    const { mutate } = client;
    variables = {
      ...variables,
      userId: sessionStorage.getItem('weFunderUserId'),
    };

    try {
      await mutate({
        mutation: updateWefunderInvestorSuitabilityMutation,
        variables,
      });

      window.location.replace(offerPreview.wefunderUrl);

      this.setState({ showsuitability: false, userId: data._id });
    } catch (error) {
      handleSnackbarError(error);
    }
  };
  register = async ({ firstName, lastName, email, offerId }) => {
    const { data } = this.props;
    const { client, handleSnackbarError } = this.props;
    const { offerPreview } = data;

    const { mutate } = client;
    const variables = {
      input: {
        firstName,
        lastName,
        email,
        offerId: offerPreview._id,
      },
    };
    try {
      const { data } = await mutate({
        mutation: wefunderRegistration,
        variables,
      });

      if (data) {
        sessionStorage.setItem(
          'weFunderUserId',
          data.createWefunderInvestorUser._id
        );
        this.handleSuitability();
      }
    } catch (error) {
      handleSnackbarError(error);
    }
  };
  render() {
    const { data, tenant } = this.props;

    if (data.loading) {
      return <Loading />;
    }
    const { offerPreview: offer } = data;

    const { issuerCompany, headerImageUrl, headerType, headerVideoId } = offer;

    const videoOptions = {
      width: 1200,
      height: 500,
      playerVars: {
        autoplay: 1,
        controls: 0,
        rel: 0,
        autohide: 1,
        showinfo: 0,
        loop: 1,
        modestbranding: 0,
        mute: 1,
        fs: 1, // Hide the full screen button
        cc_load_policy: 1, // Hide closed captions
        iv_load_policy: 3, // Hide the Video Annotations
      },
    };

    if (headerVideoId && headerVideoId.includes('youtube')) {
      //Sort the videoId from youtube link using regex
      var regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      var match = headerVideoId.match(regExp);
      var videoId = match && match[7].length == 11 ? match[7] : false;
    }
    return (
      <div>
        <Dialog open={this.state.showRegister}>
          <DialogTitle>{'Registration'}</DialogTitle>
          <Divider />
          <DialogContent>
            <DialogContentText></DialogContentText>
            <RegisterForm register={this.register} />
          </DialogContent>
        </Dialog>

        <Dialog
          transition={this.transition}
          onClose={this.handleClose}
          fullWidth={true}
          fullScreen
          maxWidth='md'
          open={this.state.showsuitability}
        >
          <DialogTitle>{'Suitability Questions'}</DialogTitle>

          <Divider />

          <WefunderSuitabilty
            issuerCompany={issuerCompany.name}
            submitSuitability={this.submitSuitability}
            offerId={offer._id}
            userId={this.state.userId}
          />
        </Dialog>

        {headerType === 'IMAGE' || !headerType ? (
          <div
            className='hero-section-inner-page services'
            style={{
              backgroundImage: `linear-gradient(3deg, rgba(0, 0, 0, .14), rgba(51, 51, 51, .11) 25%, hsla(0, 0%, 100%, 0)), linear-gradient(180deg, rgba(12, 51, 97, .49), rgba(12, 51, 97, .49)), url(${headerImageUrl})`,
              backgroundPosition: 'center',
              marginTop: 65,
            }}
          >
            <div className='hero-wrapper inner-page' data-ix='nav-scroll'>
              <h1 className='title' data-ix='home-title-animate-inner-page'>
                {issuerCompany.name}
              </h1>
            </div>
          </div>
        ) : (
          <header>
            {videoId ? (
              <YoutubeBackground
                videoId={videoId}
                // aspectRatio='2.35.1'
                // overlay="rgba(0,0,0,.3)"
                playerOptions={videoOptions}
                className='video-background'
              />
            ) : (
              <video
                playsInline='playsinline'
                autoPlay='autoplay'
                muted='muted'
                loop='loop'
              >
                <source src={headerVideoId} type='video/mp4' />
              </video>
            )}

            <div className='hero-wrapper inner-page' data-ix='nav-scroll'></div>
          </header>
        )}

        <div className='section'>
          <div className='max-width-div'>
            <AnonOfferListItems
              offer={offer}
              handleRegistration={this.handleRegistration}
              disableField={true}
            />
            <OfferDetails offer={offer} disabledRepublic={true} />
          </div>

          <div className='sub-section' id='company'>
            <CompanySummary {...issuerCompany} />
          </div>
        </div>
        <Footer tenant={tenant} />
      </div>
    );
  }
}

WefunderOffer.propTypes = {
  data: PropTypes.object.isRequired,
};

const withNotice = (Component) => (props) =>
  (
    <Fragment>
      <Component {...props} />
    </Fragment>
  );

export default connect()(
  withNotice(
    withLayout(
      withApollo(
        withAlertHandler(
          compose(
            graphql(offerPreviewQuery, {
              options: ({ match }) => ({
                variables: {
                  _id: match.params.id,
                },
              }),
            })
          )(withStyles(styles)(WefunderOffer))
        )
      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/components/WefunderOffer/index.js